<script lang="ts">
  import type { MeterRow } from '../../game/meter';

  let {
    damage,
    healing,
    seconds,
    onreset,
  }: {
    damage: MeterRow[];
    healing: MeterRow[];
    seconds: number;
    /** Practice only: starts a fresh count. */
    onreset?: () => void;
  } = $props();

  let tab = $state<'damage' | 'healing'>('damage');
  const rows = $derived(tab === 'damage' ? damage : healing);
  const total = $derived(rows.reduce((sum, r) => sum + r.amount, 0));
  const top = $derived(Math.max(1, rows[0]?.amount ?? 0));
  const short = (n: number) =>
    n >= 10000 ? `${(n / 1000).toFixed(1)}k` : `${Math.round(n)}`;
</script>

<div class="meter panel">
  <header>
    <button class:active={tab === 'damage'} onclick={() => (tab = 'damage')}
      >Damage</button
    >
    <button class:active={tab === 'healing'} onclick={() => (tab = 'healing')}
      >Healing</button
    >
    <span class="total">{short(total)} ({short(total / seconds)}/s)</span>
    {#if onreset}<button class="reset" onclick={onreset} title="Reset">↺</button
      >{/if}
  </header>
  {#each rows as row (row.id)}
    <div class="row">
      <div
        class="fill"
        class:heal={tab === 'healing'}
        style:width="{(row.amount / top) * 100}%"
      ></div>
      <img src="/icons/{row.icon}.webp" alt="" />
      <span class="name">{row.name}</span>
      <span class="amount"
        >{short(row.amount)} ({short(row.amount / seconds)}, {Math.round(
          (row.amount / Math.max(1, total)) * 100,
        )}%)</span
      >
    </div>
  {:else}
    <p class="empty">Nothing yet</p>
  {/each}
</div>

<style>
  .meter {
    width: 280px;
    padding: 6px;
    font-size: 12px;
    pointer-events: auto;
    user-select: none;
  }
  header {
    display: flex;
    align-items: center;
    gap: 4px;
    margin-bottom: 4px;
  }
  header button {
    padding: 1px 8px;
    font-size: 12px;
    opacity: 0.6;
  }
  header button.active {
    opacity: 1;
    border-color: var(--gold);
  }
  .total {
    flex: 1;
    text-align: right;
    color: var(--muted);
    font-variant-numeric: tabular-nums;
  }
  header .reset {
    padding: 1px 6px;
    opacity: 1;
  }
  .row {
    position: relative;
    display: flex;
    align-items: center;
    gap: 6px;
    height: 20px;
    margin-top: 2px;
    background: rgba(0, 0, 0, 0.35);
    overflow: hidden;
  }
  .fill {
    position: absolute;
    inset: 0 auto 0 0;
    background: linear-gradient(#b98a1c, #6e5210);
  }
  .fill.heal {
    background: linear-gradient(#3f8a2a, #22501a);
  }
  .row img {
    position: relative;
    width: 20px;
    height: 20px;
  }
  .name,
  .amount {
    position: relative;
    text-shadow: 0 1px 2px black;
    white-space: nowrap;
  }
  .name {
    flex: 1;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .amount {
    padding-right: 4px;
    font-variant-numeric: tabular-nums;
  }
  .empty {
    margin: 6px 0 2px;
    color: var(--muted);
    text-align: center;
  }
</style>
